<template>
  <div class="col-lg-12">
    <div class="panel blank-panel">
      <div class="panel-heading">
        <div class="panel-options">
          <ul class="nav nav-tabs">
            <li class="active"><a class="nav-link" data-toggle="tab" @click="activeComponent='taskData'">Task Data</a></li>
          </ul>
        </div>
      </div>
      <div class="panel-body">
        <div class="tab-content">
          <div class="tab-pane active">
            <div>
              <component :is="activeComponent"></component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TaskData from './Tabs/TaskData.vue'

export default {
  data () {
    return {
      activeComponent: 'taskData'
    }
  },
  components: {
    taskData: TaskData
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Tasks/Single/Content/Content.vue